import { Injectable } from '@angular/core';
import { EventManagerAdminService } from './event-manager/event-manager-admin.service';
import { HelperManagerAdminService } from './helper-manager-admin.service';
type YtObject = {
  currentPlayPosition: number;
  currentState: number;
  lastEvent: number;
  lastPlayPosition: number;
  lastState: number;
  player: {
    playVideo: () => Promise<void>;
    pauseVideo: () => Promise<void>;
    stopVideo: () => Promise<void>;
    seekTo: (seconds: number, allowSeekAhead: boolean) => Promise<void>;
    mute: () => Promise<void>;
    unMute: () => Promise<void>;
    setPlaybackRate: (rate: number) => Promise<void>;
    setVolume: (volume: number) => Promise<void>;
    loadVideoById: (data: { videoId: string, startSeconds?: number, endSeconds?: number }) => Promise<void>;
  }
}
@Injectable({
  providedIn: 'root'
})
export class YoutubeManagerService {
  public youtube!: YtObject;
  constructor(private eventManager: EventManagerAdminService, private ragAiHelper: HelperManagerAdminService
  ) {
    this.eventManager.on('RAGAI.YOUTUBE.playerready', (_event, youtubeObj) => {
      this.youtube = youtubeObj as YtObject;
    });
  }
  public async play() {
    this.eventManager.trigger('RAGAI.YOUTUBE.PLAY', {});
    await this.youtube.player.playVideo();
  }

  public async pause() {
    this.eventManager.trigger('RAGAI.YOUTUBE.PAUSE', {});
    await this.youtube.player.pauseVideo();
  }

  public async stop() {
    this.eventManager.trigger('RAGAI.YOUTUBE.STOP', {});
    await this.youtube.player.stopVideo();
  }

  public async mute() {
    this.eventManager.trigger('RAGAI.YOUTUBE.MUTE', {});
    await this.youtube.player.mute();
  }

  public async unmute() {
    this.eventManager.trigger('RAGAI.YOUTUBE.UNMUTE', {});
    await this.youtube.player.unMute();
  }

  public async setPlaybackRate(rate: number) {
    this.eventManager._trigger_RAGAI_EVENT('RAGAI.YOUTUBE.SETPLAYBACKRATE', {});
    await this.youtube.player.setPlaybackRate(rate);
  }

  public async setVolume(volume: number) {
    this.eventManager._trigger_RAGAI_EVENT('RAGAI.YOUTUBE.SETVOLUME', {});
    await this.youtube.player.setVolume(volume);
  }

  public async seekTo(hours: number, minutes: number, seconds: number, allowSeekAhead = true) {
    this.eventManager._trigger_RAGAI_EVENT('RAGAI.YOUTUBE.SEEKTO', { seconds });
    seconds = this.ragAiHelper.timeToSeconds(hours, minutes, seconds);
    await this.youtube.player.seekTo(seconds, allowSeekAhead);
  }

  public async loadVideo(videoId: string, startSeconds?: number, endSeconds?: number) {
    if (startSeconds && startSeconds < 1) startSeconds = undefined;
    if (endSeconds && endSeconds < 1) endSeconds = undefined;
    this.eventManager._trigger_RAGAI_EVENT('RAGAI.YOUTUBE.CHANGEVIDEO', {});
    await this.youtube.player.loadVideoById({ videoId, startSeconds, endSeconds });
  }
}
